<template>
  <div class="contractTemplate" >
    <el-divider content-position="left">合同模板</el-divider>
    <el-row>
      <el-col :span="24" class="tr">
        <el-button type="primary" size="mini" @click="submitAdd">更新模板</el-button>
      </el-col>
    </el-row>

    <el-table height="calc(100vh - 266px)" :data="pageData" size="mini" border style="width: 100%; margin-top: .2rem" v-cloak>
      <el-table-column label="模板ID">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.template_id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="模板名称">
        <template slot-scope="scope">
            <span class="hide-style">{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="模板类型" prop="template_type"></el-table-column>
      <el-table-column label="创建人" prop="founder"></el-table-column>
<!--       <el-table-column label="示例截图" prop="mobile">
        <template slot-scope="scope">
          <el-tooltip content="控件示例截图" placement="top">
            <i v-if="scope.row.images.length > 0" class="el-icon-picture-outline" style="font-size: 20px; color: #409EFF; cursor: pointer;" @click="handleShowImagesOpen(scope.row.images)"></i>
          </el-tooltip>
        </template>
      </el-table-column> -->
<!--       <el-table-column fixed="right" label="操作" width="140">
        <template slot-scope="scope">
          <el-tooltip class="item"  effect="dark" content="下载模板" placement="top">
            <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleLoad(scope.row.pdf_url)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="page-footer">
    <el-pagination
      background
      class="pagination-style"
      layout="sizes, total, prev, pager, next, jumper"
      :hide-on-single-page="false"
      :current-page="pageOption.currentPage"
      :page-size="pageOption.pageSize"
      :page-sizes="[10, 20, 30, 50, 100, 500]"
      :total="pageOption.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
  </div>
</template>

<script>
export default {
  name: 'ContractTemplate',
  data () {
    return {

      uploadHeader: {Authorization: localStorage.token},
      pageData: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        searchCurrentPage: 1, // 搜索后页码
        pageSize: 30 // 每页显示条数
      },
      searchArr: {
        company_id: ''
      }
    }
  },
  computed: {
    searchStr: function () {
      let str = ''
      for (let key in this.searchArr) {
        str += '&' + key + '=' + this.searchArr[key]
      }

      return str
    },    
    collapse () {
      return this.$store.state.collapse
    }
  },
  methods: {
    getPageData () {
      this.$axios.get('/api/admin/qz_electronic_contract_templates?page=' + this.pageOption.currentPage + '&pageSize=' + this.pageOption.pageSize)
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageData = data.data.templates.data
            this.pageOption.total = data.data.templates.total
          }
        })
    },
    handleSizeChange (val) {
      this.pageOption.pageSize = val
      this.getCompanies()
    },
    handleCurrentChange (val) {
      this.pageOption.currentPage = val
      this.getCompanies()
    },
    submitAdd () {
      this.$axios.post('/api/admin/qz_electronic_contract_templates/refresh')
        .then((res) => {
          let { data } = res
          if (data.code === 0) {
            this.pageOption.currentPage = 1
            this.getPageData()
            this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg)
          }
        })
    },
    handleLoad (url) {
      window.open(url)
    }
  },
  mounted () {
    this.getPageData()
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'
[v-cloak]
  display: none
.el-drawer__wrapper >>> .el-drawer
  overflow-y: auto
.el-collapse
  border-bottom 0
  border-top 0
.el-collapse >>> .el-collapse-item__header
  color: #4C87FC
  font-weight bold
.el-collapse >>> .el-collapse-item__arrow
  color: #4C87FC
.companies >>> .el-table__header th
  color: #333333
  background-color: #ECF4FF
.contractTemplate
  marginLeft()
  .hide-style
    display: inherit
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
.tr
  text-align: right
.mt-10
  margin-top: .2rem
.mt-20
  margin-top: .4rem
.el-form-item
  margin-bottom: .4rem
.el-form .el-select
  width: 100%
.el-dialog .el-select
  width: 100%
.page-footer
  position: fixed
  bottom: 0
  left: 0
  height: 80px
  background: #fff
  width: 100%
  z-index: 2
.pagination-style
  padding-top: 15px
  text-align: right
</style>



// WEBPACK FOOTER //
// src/pages/contract/ContractTemplate.vue